import ActionResult from 'app/src/engine/action-results/ActionResult';
import MovableItem from 'app/src/engine/movable-items/MovableItem';
import GameStateStore from 'app/src/game/GameStateStore';

export enum InstructionSegmentStatus {
	Success,
	CancelFutureSegments,
}

export default class InstructionSegment {
	public getActionResults(
		_gameStateStore: GameStateStore,
		_movableItem: MovableItem,
	): { status: InstructionSegmentStatus; actionResults: ActionResult[] } {
		throw new Error('Subclasses must override.');
	}
}
